/*
*###############################################################################
*Module Name                   : ReportMaster.js                          #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               : I Dinisuru Balasuriya                         #
*Date                          : Monday, August 30th 2021, 10:14:01 am         #
*Copyright © 2021 myPOS Software Solution (pvt Ltd.)                           #
*###############################################################################
*/

import React, { useState, useEffect } from 'react'
import { MetaTags } from 'react-meta-tags'
import {
    Card,
    Col,
    Container,
    Row,
    CardBody,
    Alert,
    TabContent,
    TabPane
} from 'reactstrap'

//**Importing required componant files   */
import Breadcrumb from 'components/Common/Breadcrumb'
import DPTopToolBar from 'framework/widgets/DPTopToolBar'
import ReportMasterContent from './ReportMasterContent'
import DPInfoBox from 'framework/layout/DPInfoBox'
import { Text } from "../../../framework/validators/TextValidation"
import DPAlert from "../../../framework/widgets/DPAlert"
import DPLoadingAlert from 'framework/widgets/DPLoadingAlert'
import DPPermission from 'framework/widgets/DPPermission'
import DPPrintOption from 'framework/widgets/DPPrintOptions'
//**End Importing required componant files */
import { Context } from '../../../app-contexts/CommonContexts';
import { useHistory } from 'react-router-dom';
import { useContext } from 'react'
import { getReportData, getselectGroup } from './ReportMasterController'
import ReportMasterTable from './ReportMasterTable'
import DPNavBar from 'framework/widgets/DPNavBar'

const ReportMaster = (props) => {

    const reportCode = props.location.search.replace('?', '',)
    const ApiURL = window.Links.ApiURL
    let history = useHistory();
    //*** User input related states */
    const [strBarCode, SetCode] = useState("");// Set Code
    const [menuCode, SetMenuCode] = useState("")
    const [reportUI, setReportUI] = useState({})
    const [groups, setGroups] = useState([])
    const [subGroups, setSubGroups] = useState([])
    const [isSubGroup, setIsSubGroup] = useState(false)
    const [currentGroup, setCurrentGroup] = useState(0)
    const [endFroups, setEndGroups] = useState(false)

    const [displayDataset, setDisplayDataset] = useState([])
    const [disable, setDisable] = useState(false)


    const [allLocations_1, setAllLocations_1] = useState([])
    const [isAllLocations_1, setIsAllLocations_1] = useState(false)

    const [allLocations_2, setAllLocations_2] = useState([])
    const [isAllLocations_2, setIsAllLocations_2] = useState(false)
    const [allCustomerGroups, setAllCustomerGroups] = useState([])
    const [isAllCustomerGroups, setIsAllCustomerGroups] = useState(false)
    const [allCustomers, setAllCustomers] = useState([])
    const [isAllCustomers, setIsAllCustomers] = useState(false)
    const [allOffers, setAllOffers] = useState([])
    const [isAllOffers, setIsAllOffers] = useState(false)
    const [allPayementMethods, setAllPayementMethods] = useState([])
    const [isAllPayementMethods, setIsAllPayementMethods] = useState(false)
    const [allProducts, setAllProducts] = useState([])
    const [isAllProducts, setIsAllProducts] = useState(false)
    const [allStaff, setAllStaff] = useState([])
    const [isAllStaff, setIsAllStaff] = useState(false)
    const [allSuppliers, setAllSuppliers] = useState([])
    const [isAllSuppliers, setIsAllSuppliers] = useState(false)
    const [allTxnTypes, setAllTxnTypes] = useState("")
    const [isAllTxnTypes, setIsAllTxnTypes] = useState(false)
    const [txnDescription, setTxnDescription] = useState("")
    const [allUsers, setAllUsers] = useState([])
    const [isAllUsers, setIsAllUsers] = useState(false)
    const [fromDate, setFromDate] = useState("")
    const [toDate, setToDate] = useState("")
    const [isAllDates, setIsAllDates] = useState(false)


    const [group1, setGroup1] = useState([])
    const [group2, setGroup2] = useState([])
    const [group3, setGroup3] = useState([])
    const [group4, setGroup4] = useState([])
    const [group5, setGroup5] = useState([])
    const [group6, setGroup6] = useState([])
    const [group7, setGroup7] = useState([])
    const [group8, setGroup8] = useState([])
    const [group9, setGroup9] = useState([])
    const [group10, setGroup10] = useState([])
    const [group11, setGroup11] = useState([])
    const [group12, setGroup12] = useState([])
    const [group13, setGroup13] = useState([])
    const [group14, setGroup14] = useState([])
    const [group15, setGroup15] = useState([])
    const [group16, setGroup16] = useState([])
    const [group17, setGroup17] = useState([])
    const [group18, setGroup18] = useState([])
    const [group19, setGroup19] = useState([])
    const [group20, setGroup20] = useState([])
    const [group21, setGroup21] = useState([])
    const [group22, setGroup22] = useState([])
    const [group23, setGroup23] = useState([])
    const [group24, setGroup24] = useState([])
    const [group25, setGroup25] = useState([])
    const [group26, setGroup26] = useState([])
    const [group27, setGroup27] = useState([])
    const [group28, setGroup28] = useState([])
    const [group29, setGroup29] = useState([])
    const [group30, setGroup30] = useState([])
    const [group31, setGroup31] = useState([])
    const [group32, setGroup32] = useState([])
    const [group33, setGroup33] = useState([])
    const [group34, setGroup34] = useState([])
    const [group35, setGroup35] = useState([])
    const [group36, setGroup36] = useState([])
    const [group37, setGroup37] = useState([])
    const [group38, setGroup38] = useState([])
    const [group39, setGroup39] = useState([])
    const [group40, setGroup40] = useState([])


    var GroupStatesArray = [
        {
            GroupNo: 1,
            setState: setGroup1,
            state: group1,
        }, {
            GroupNo: 2,
            setState: setGroup2,
            state: group2,
        }, {
            GroupNo: 3,
            setState: setGroup3,
            state: group3,
        }, {
            GroupNo: 4,
            setState: setGroup4,
            state: group4,
        }, {
            GroupNo: 5,
            setState: setGroup5,
            state: group5,
        }, {
            GroupNo: 6,
            setState: setGroup6,
            state: group6,
        }, {
            GroupNo: 7,
            setState: setGroup7,
            state: group7,
        }, {
            GroupNo: 8,
            setState: setGroup8,
            state: group8,
        }, {
            GroupNo: 9,
            setState: setGroup9,
            state: group9,

        }, {
            GroupNo: 10,
            setState: setGroup10,
            state: group10,

        }, {
            GroupNo: 11,
            setState: setGroup11,
            state: group11,

        }, {
            GroupNo: 12,
            setState: setGroup12,
            state: group12,
        }, {
            GroupNo: 13,
            setState: setGroup13,
            state: group13,
        }, {
            GroupNo: 14,
            setState: setGroup14,
            state: group14,
        }, {
            GroupNo: 15,
            setState: setGroup15,
            state: group15,
        }, {
            GroupNo: 16,
            setState: setGroup16,
            state: group16,
        }, {
            GroupNo: 17,
            setState: setGroup17,
            state: group17,
        }, {
            GroupNo: 18,
            setState: setGroup18,
            state: group18,
        }, {
            GroupNo: 19,
            setState: setGroup19,
            state: group19,
        }, {
            GroupNo: 20,
            setState: setGroup20,
            state: group20,
        }, {
            GroupNo: 21,
            setState: setGroup21,
            state: group21,

        }, {
            GroupNo: 22,
            setState: setGroup22,
            state: group22,
        }, {
            GroupNo: 23,
            setState: setGroup23,
            state: group23,
        }, {
            GroupNo: 24,
            setState: setGroup24,
            state: group24,
        }, {
            GroupNo: 25,
            setState: setGroup25,
            state: group25,
        }, {
            GroupNo: 26,
            setState: setGroup26,
            state: group26,
        }, {
            GroupNo: 27,
            setState: setGroup27,
            state: group27,
        }, {
            GroupNo: 28,
            setState: setGroup28,
            state: group28,
        }, {
            GroupNo: 29,
            setState: setGroup29,
            state: group29,
        }, {
            GroupNo: 30,
            setState: setGroup30,
            state: group30,
        }, {
            GroupNo: 31,
            setState: setGroup31,
            state: group31,
        }, {
            GroupNo: 32,
            setState: setGroup32,
            state: group32,
        }, {
            GroupNo: 33,
            setState: setGroup33,
            state: group33,
        }, {
            GroupNo: 34,
            setState: setGroup34,
            state: group34,
        }, {
            GroupNo: 35,
            setState: setGroup35,
            state: group35,
        }, {
            GroupNo: 36,
            setState: setGroup36,
            state: group36,
        }, {
            GroupNo: 37,
            setState: setGroup37,
            state: group37,
        }, {
            GroupNo: 38,
            setState: setGroup38,
            state: group38,
        }, {
            GroupNo: 39,
            setState: setGroup39,
            state: group39,
        }, {
            GroupNo: 40,
            setState: setGroup40,
            state: group40,
        }
    ]



    const [isLocation_1_open, setisLocation_1_open] = useState(false)
    const [isLocation_2_open, setisLocation_2_open] = useState(false)
    const [isCustomerGroup_open, setisCustomerGroup_open] = useState(false)
    const [isCustomer_open, setisCustomer_open] = useState(false)
    const [isOffer_open, setisOffer_open] = useState(false)
    const [isPayementMethod_open, setisPayementMethod_open] = useState(false)
    const [isProduct_open, setisProduct_open] = useState(false)
    const [isStaff_open, setisStaff_open] = useState(false)
    const [isSupplier_open, setisSupplier_open] = useState(false)
    const [isTxnType_open, setisTxnType_open] = useState(false)
    const [isUser_open, setisUser_open] = useState(false)

    function toggleLocation1() {
        setisLocation_1_open(!isLocation_1_open)
    }

    function toggleLocation2() {
        setisLocation_2_open(!isLocation_2_open)
    }

    function toggleCustomerGroup() {
        setisCustomerGroup_open(!isCustomerGroup_open)
    }

    function toggleCustomer() {
        setisCustomer_open(!isCustomer_open)
    }

    function toggleOffer() {
        setisOffer_open(!isOffer_open)
    }

    function togglePayementMethod() {
        setisPayementMethod_open(!isPayementMethod_open)
    }

    function toggleProduct() {
        setisProduct_open(!isProduct_open)
    }

    function toggleStaff() {
        setisStaff_open(!isStaff_open)
    }

    function toggleSupplier() {
        setisSupplier_open(!isSupplier_open)
    }

    function toggleTxnType() {
        setisTxnType_open(!isTxnType_open)
    }

    function toggleUser() {
        setisUser_open(!isUser_open)
    }

    //*** End User input related states */

    //*** User Activity related states*/
    const [show, setShow] = useState(false)
    const [AlertMsg, setAlertMsg] = useState('')
    const [AlertColor, setAlertColor] = useState('')
    const [saveEnable, setSaveEnable] = useState(false)
    const [crEnable, setCrEnable] = useState(false)
    const [crBy, setCrBy] = useState("")
    const [mdBy, setMdBy] = useState("")
    const [crDate, setCrDate] = useState("")
    const [mdDate, setMdDate] = useState("")
    const [deleteEnable, SetDeleteEnable] = useState(false)
    const [Reason, setReason] = useState("Created")
    const [editEnable, SetEditEnable] = useState(false)
    const [printEnable, SetPrintEnable] = useState(true)
    //*** End User activity related staes */

    //Alert Parameters
    const [sweetAlertShow, setsweetAlertShow] = useState(false)
    const [AlertDescription, setAlertDescription] = useState(false)
    const [AlertConfirmOption, setAlertConfirmOption] = useState(0)
    const [ErrorMsg, setErrorMsg] = useState('')
    const [addNew, SetAddNew] = useState(true)
    //*** Get and Set values when user search code */

    //*****Menu Rights Start*/
    const [menuAccess, SetMenuAccess] = useState(false)
    const [menuCreate, SetMenuCreate] = useState(false)
    const [menuDelete, SetMenuDelete] = useState(false)
    const [menuModify, SetMenuModify] = useState(false)
    const [menuPrint, SetMenuPrint] = useState(false)
    const [menuProcess, SetMenuProcess] = useState(false)
    const [menuName, SetMenuName] = useState("")
    const [parentName, SetParentName] = useState("")
    const [LocationCode, setLocationCode] = useState("")
    const [LogUserType, setLogUserType] = useState("")
    const [LogCompanyCode, setLogCompanyCode] = useState("")
    //*****Menu Rights End */

    /**********Loading Alert */
    const [loadingAlert, SetLoadingAlert] = useState(false)
    const [loadingAlertTitle, SetLoadingAlerttitle] = useState("")
    /**********End Loading Alert */

    //User Permission related usestates
    const [permissionAlertShow, setPermissionAlertShow] = useState(false)
    const [permissionAlertTitle, setPermissionAlertTitle] = useState("")
    const [permissionReasonShow, setPermissionReasonShow] = useState(false)
    const [permissionName, setPermissionName] = useState("")
    const [permissionPassword, setPermissionPassword] = useState("")
    const [permissionNameDisable, setPermissionNameDisable] = useState(false)
    const [printoptionShow, setprintoptionShow] = useState(false)
    const [helpUrl, setHelpUrl] = useState("")

    //**Set Active Tab panel */
    const [customActiveTab, setcustomActiveTab] = useState("1")
    const toggleCustom = tab => {
        if (customActiveTab !== tab) {
            setcustomActiveTab(tab)
        } else {
            setcustomActiveTab("1")
        }
    }


    var time = process.env.REACT_APP_ALERTTIMEOUT
    const authToken = localStorage.getItem("authToken")
    const {
        getMenuDetails, addtoFavourite
    } = useContext(Context);
    //**Get File Details */
    useEffect(async () => {
        const authToken = localStorage.getItem("authToken")
        var obj = JSON.parse(localStorage.getItem("authUser"))
        var LogUserType = obj[2]
        var menuDetail = await getMenuDetails(window.location.pathname + window.location.search)
        var menu = menuDetail && menuDetail.menuTag ? menuDetail.menuTag : history.push('/dashboard');
        var parentname = menuDetail?.parentName
        SetParentName(parentname)
        var LocationCode = obj[3]
        var LocationDesc = obj[4]
        var CompanyCode = obj[5]
        setLocationCode(LocationCode)
        setLogUserType(LogUserType)
        setLogCompanyCode(CompanyCode)
        const ApiURL = window.Links.ApiURL

        var requestOptions = {
            method: 'GET',
            headers: {
                "Authorization": `Bearer ${authToken}`
            },
            redirect: 'follow'
        };

        fetch(`${ApiURL}login/menu/${LogUserType}/${menu}`, requestOptions)
            .then(response => response.json())
            .then(result => {
                SetMenuAccess(result.data.strMenuAccessRight)
                SetMenuCreate(result.data.strMenuCreateRight)
                SetMenuDelete(result.data.strMenuDeleteRight)
                SetMenuModify(result.data.strMenuModifyRight)
                SetMenuPrint(result.data.strMenuPrintRight)
                SetMenuProcess(result.data.strMenuProcessRight)
                SetMenuName(result.data.strMenuName)
                SetMenuCode(result.data.strMenuTag)
                setPermissionReasonShow(result.data.strMenuReasonShow)
setHelpUrl(result.data.strHelpUrl)
            }).catch(error =>
                console.log('error', error)
            );

    }, [strBarCode, reportCode])

    useEffect(async () => {
        const authToken = localStorage.getItem("authToken")
        const ApiURL = window.Links.ApiURL
        var obj = JSON.parse(localStorage.getItem("authUser"))
        var LogUserType = obj[2]
        var LocationCode = obj[3]
        var LocationName = obj[4]
        var CompanyCode = obj[5]
        var menuDetail = await getMenuDetails(window.location.pathname + window.location.search)
        var menu = menuDetail && menuDetail.menuTag ? menuDetail.menuTag : history.push('/dashboard');
        var parentname = menuDetail?.parentName


        var menuTAG = ""
        const AuditLog = {
            "strMenuCode": menu,
            "strUserName": LogUserType,
            "strLocCode": LocationCode,
            "strComcode": CompanyCode,
            "strReason": ""
        }
        var requestOptions = {
            method: 'POST',
            headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` },
            body: JSON.stringify(AuditLog),
        };

        fetch(`${ApiURL}login/menu/audit`, requestOptions)
            .then(async (response) => await response.json())
            .then(result => {
                console.log(result)
            }).catch(error =>
                console.log('error', error)
            );

    }, [])


    useEffect(async () => {

        SetLoadingAlert(true)
        SetLoadingAlerttitle("UI Loading...")
        var ui = await getReportData(reportCode)
        SetLoadingAlert(false)
        // var groupsData = await getselectGroup()

        // setGroups(groupsData.data)

        if (ui.isSuccess) {
            setReportUI(ui.data[0])
        }
        ClearItem()


    }, [reportCode])



    //save button function
    const handlesave = async (type, report = 1) => {


        if (reportUI.R_LOCATIONFILTER1 == 1 && isAllLocations_1 == false && allLocations_1.length == 0) {
            displayAlertMessage('danger', "Please Select Location 1")
            return
        }

        if (reportUI.R_LOCATIONFILTER2 == 1 && isAllLocations_2 == false && allLocations_2.length == 0) {
            displayAlertMessage('danger', "Please Select Location 2")
            return
        }

        if (reportUI.R_DATEFILTER1 == 1 && fromDate == "" && toDate == "") {
            if (isAllDates == false) {
                displayAlertMessage('danger', "Please Select Date Range")
                return
            }

        }

        if (reportUI.R_CUSTOMERGROUPFILTER == 1 && isAllCustomerGroups == false && allCustomerGroups.length == 0) {
            displayAlertMessage('danger', "Please Select Customer Group")
            return
        }

        if (reportUI.R_PRODUCTFILTER == 1 && isAllProducts == false && allProducts.length == 0) {
            displayAlertMessage('danger', "Please Select Product")
            return
        }

        if (reportUI.R_TRANSACTIONTYPEFILTER == 1 && isAllTxnTypes == false && allTxnTypes.length == 0) {
            displayAlertMessage('danger', "Please Select Transaction Type")
            return
        }

        if (reportUI.R_GROUPFILTER == 1 && endFroups == false) {
            displayAlertMessage('danger', "Please Select Group")
            return
        }

        if (reportUI.R_CUSTOMERFILTER == 1 && isAllCustomers == false && allCustomers.length == 0) {
            displayAlertMessage('danger', "Please Select Customer")
            return
        }


        if (reportUI.R_SUPPLIERFILTER == 1 && isAllSuppliers == false && allSuppliers.length == 0) {
            displayAlertMessage('danger', "Please Select Supplier")
            return
        }

        if (reportUI.R_STAFFFILTER == 1 && isAllStaff == false && allStaff.length == 0) {
            displayAlertMessage('danger', "Please Select Staff")
            return
        }

        if (reportUI.R_USERFILTER == 1 && isAllUsers == false && allUsers.length == 0) {
            displayAlertMessage('danger', "Please Select User")
            return
        }


        if (reportUI.R_PAYMODEFILTER == 1 && isAllPayModes == false && allPayModes.length == 0) {
            displayAlertMessage('danger', "Please Select Pay Mode")
            return
        }

        const groupsets = Array(40).fill(null).map(() => []);

        GroupStatesArray.forEach((item) => {
            const grouptemp = item.state.filter((item2) => item2.ischecked).map((item2) => ({ Code: item2.value }));

            if (grouptemp.length > 0) {
                groupsets[item.GroupNo - 1] = grouptemp;
            }
        });



        var dataBody = {
            user: LogUserType,
            menuCode: reportCode,
            allLocation1: isAllLocations_1,
            locations1: getDataset(allLocations_1),
            allLocation2: isAllLocations_2,
            locations2: getDataset(allLocations_2),
            allSuppliers: isAllSuppliers,
            suppliers: getDataset(allSuppliers),
            fromDate: fromDate,
            toDate: toDate,
            isAllDate: isAllDates,
            allUsers: isAllUsers,
            users: getDataset(allUsers),
            allCustomers: isAllCustomers,
            customers: getDataset(allCustomers),
            allProducts: isAllProducts,
            products: getDataset(allProducts),
            transactions: allTxnTypes,
        }

        //add groupsets to dataBody
        groupsets.forEach((groupset, index) => {
            dataBody[`group${index + 1}`] = groupset;
        });

        var requestOptions = {
            method: 'POST',
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${authToken}`
            },
            body: JSON.stringify(dataBody),
        };

        if (type == "save") {

            SetLoadingAlert(true)
            SetLoadingAlerttitle("Getting Data...")

            fetch(`${ApiURL}myReport/generate`, requestOptions)
                .then(async (response) => await response.json())
                .then(result => {
                    SetLoadingAlert(false)
                    setDisplayDataset(JSON.parse(result.data))
                    if (JSON.parse(result.data).length > 0) {
                        setDisable(true)
                        toggleCustom("2")
                    } else {
                        displayAlertMessage('danger', "No Data Found")
                    }
                }).catch(error => {
                    console.log('error', error)
                    SetLoadingAlert(false)
                }
                );
        } else {
            SetLoadingAlert(true)
            SetLoadingAlerttitle("Printing Data...")

            const ReportURL = window.Links.ReportURL

            fetch(`${ApiURL}myReport/generate/report/${report}`, requestOptions)
                .then(async (response) => await response.json())
                .then(result => {
                    if (result.success == true) {
                        SetLoadingAlert(false)
                        var msg = result.data
                        if (report == 1) {
                            window.open(`${ReportURL}temp_print/${msg.replace("\r\n", '')}.pdf`)
                        } else {
                            window.open(`${ReportURL}temp_print/${msg.replace("\r\n", '')}.xlsx`)
                        }
                    } else {
                        SetLoadingAlert(false)
                    }
                }).catch(error => {
                    console.log('error', error)
                    SetLoadingAlert(false)
                }
                );
        }
    }


    function getDataset(objArray) {
        var dataset = []

        objArray.map((item, index) => {
            dataset.push(
                {
                    Code: item,
                }
            )
        })
        return dataset
    }


    //edit button function    
    const handleEdit = e => {
        setDisabled(false)
        setDisabledCode(true)
        setSaveEnable(false)
        SetDeleteEnable(true)
        SetEditEnable(false)
    }

    //new button function
    const handleNew = e => {
        //e.preventDefault()
        ClearItem();
        setShow(false)
        setSaveEnable(false)
        setCrEnable(false)
    }

    //clear fields function    
    const ClearItem = async () => {

        setAllLocations_1([])
        setIsAllLocations_1(false)
        setAllLocations_2([])
        setIsAllLocations_2(false)
        setAllCustomers([])
        setIsAllCustomers(false)
        setAllOffers([])
        setIsAllOffers(false)
        setAllPayementMethods([])
        setIsAllPayementMethods(false)
        setAllProducts([])
        setIsAllProducts(false)
        setAllStaff([])
        setIsAllStaff(false)
        setAllSuppliers([])
        setIsAllSuppliers(false)
        setAllTxnTypes("")
        setIsAllTxnTypes(false)
        setTxnDescription("")
        setAllUsers([])
        setIsAllUsers(false)
        setFromDate("")
        setToDate("")
        setIsAllDates(false)

        setGroup1([])
        setGroup2([])
        setGroup3([])
        setGroup4([])
        setGroup5([])
        setGroup6([])
        setGroup7([])
        setGroup8([])
        setGroup9([])
        setGroup10([])
        setGroup11([])
        setGroup12([])
        setGroup13([])
        setGroup14([])
        setGroup15([])
        setGroup16([])
        setGroup17([])
        setGroup18([])
        setGroup19([])
        setGroup20([])
        setGroup21([])
        setGroup22([])
        setGroup23([])
        setGroup24([])
        setGroup25([])
        setIsSubGroup(false)
        setSubGroups([])
        setDisplayDataset([])
        setEndGroups(false)
        setDisable(false)
        toggleCustom("1")

        var groupsData = await getselectGroup()

        setGroups(groupsData.data)

    }

    //********Delete button function */
    const handleDelete = () => {

    }
    //*********Delete button function end */



    //**Permission Check */
    const permission = (operation) => {

        const permissiondata = {
            strUsername: permissionName,
            strPassword: permissionPassword,
            strLocation: LocationCode,
            strMenuCode: menuCode
        }

        clearPermissionInputs()

        fetch(`${ApiURL}login/userpermission`,
            {
                method: "POST",
                headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` },
                body: JSON.stringify(permissiondata)
            }
        ).then(Response => {
            if (Response.status == "200") {
                Response.json()
                    .then(responseData => {
                        let Access = (responseData.data.strMenuAccessRight)
                        let Create = (responseData.data.strMenuCreateRight)
                        let Delete = (responseData.data.strMenuDeleteRight)
                        let Modify = (responseData.data.strMenuModifyRight)
                        let Print = (responseData.data.strMenuPrintRight)
                        let Process = (responseData.data.strMenuProcessRight)

                        if (operation == "Save") {
                            if (Create == true) {
                                handlesave()
                            } else if (Modify == true) {
                                handlesave()
                            } else {
                                if (operation == "Save" && addNew == true) {
                                    displayAlertMessage('danger', "This user dosen't have permission to save")
                                } else {
                                    displayAlertMessage('danger', "This user dosen't have permission to edit")
                                }
                            }
                        } else if (operation == "Delete") {
                            if (Delete == true) {
                                handleDelete()
                            } else {
                                displayAlertMessage('danger', "This user don't have permission to delete !")
                            }
                        } else if (operation == "Print") {
                            if (Print == true) {
                                setprintoptionShow(true)
                            } else {
                                displayAlertMessage('danger', "This user don't have permission to print !")
                            }
                        }
                    }
                    )

            } else if (Response.status == "400") {
                setDisabled(false)
                setDisabledCode(false)
                displayAlertMessage('danger', "Oops something went wrong !")
                clearPermissionInputs()

            } else if (Response.status == "403") {
                setDisabled(false)
                setDisabledCode(false)
                displayAlertMessage('danger', "You have not Permission to make changes !")
                clearPermissionInputs()

            } else if (Response.status == "404") {
                setDisabled(false)
                setDisabledCode(false)
                displayAlertMessage('danger', "Password or User Name is Invalid !")
                clearPermissionInputs()

            } else {
                ClearItem()
            }
        }).catch(error => {
            console.log(error.message)
        })
    }



    const newTabList = [
        {
            text: "General",
            icon: "fas fa-home",
            tabID: "1",
            onClick: () => {
                toggleCustom("1")
            },
        },
        {
            text: "Data",
            icon: "fas fa-home",
            tabID: "2",
            onClick: () => {
                toggleCustom("2")
            },
        },
    ]

    // Function for displaying Alert Messages.
    function displayAlertMessage(color, message) {
        setAlertColor(color)
        setAlertMsg(message)
        setShow(true)

        setTimeout(() => {
            setShow(false)
        }, time)
    }


    //handle permission alert
    function handlePermissionAlert(LogUserType, reason, disable, alertShow) {
        setPermissionName(LogUserType)
        setReason(reason)
        setPermissionNameDisable(disable)
        setPermissionAlertShow(alertShow)
    }


    //Clear permission name & password
    function clearPermissionInputs() {
        setPermissionName("");
        setPermissionPassword("");
        setReason("");
    }


    //Handle Favourite Button
    const handleFavourite = async () => {
        var response = await addtoFavourite(menuCode, LogUserType);
    }


    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags>
                    <title>{menuName}</title>
                </MetaTags>
                <Container fluid={true}>
                    <Breadcrumb title={parentName} breadcrumbItem={menuName}></Breadcrumb>
                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardBody>
                                    <DPAlert
                                        confirm_both={sweetAlertShow}
                                        title={menuName}
                                        description={AlertDescription}
                                        showCancel={true}
                                        btnColor={"success"}
                                        cancelColor={"danger"}
                                        onConfirm={() => {
                                            setsweetAlertShow(false)
                                            if (AlertConfirmOption == 1) {
                                                if (addNew == true && menuCreate == true && permissionReasonShow == false) {
                                                    handlesave()
                                                } else if (addNew == true && menuCreate == true && permissionReasonShow == true) {
                                                    handlePermissionAlert(LogUserType, "Created", true, true)
                                                } else if (addNew == false && menuModify == true && permissionReasonShow == false) {
                                                    handlesave()
                                                } else if (addNew == false && menuModify == true && permissionReasonShow == true) {
                                                    handlePermissionAlert(LogUserType, "Updated", true, true)
                                                } else {
                                                    setPermissionReasonShow(true)
                                                    setPermissionAlertShow(true)
                                                }

                                            } else if (AlertConfirmOption == 2) {
                                                handleEdit()
                                            } else if (AlertConfirmOption == 3) {
                                                window.location.href = "/";
                                            } else if (AlertConfirmOption == 4) {
                                                handleNew()
                                            } else if (AlertConfirmOption == 6) {
                                                if (menuPrint == true && permissionReasonShow == false) {
                                                    setprintoptionShow(true)
                                                } else if (menuPrint == true && permissionReasonShow == true) {
                                                    handlePermissionAlert(LogUserType, "Printed", true, true)
                                                } else {
                                                    setPermissionReasonShow(true)
                                                    setPermissionAlertShow(true)
                                                }
                                            } else if (AlertConfirmOption == 5) {

                                                if (addNew == false && menuDelete == true && permissionReasonShow == false) {
                                                    handleDelete()
                                                } else if (addNew == false && menuDelete == true && permissionReasonShow == true) {
                                                    handlePermissionAlert(LogUserType, "Deleted", true, true)
                                                } else {
                                                    setPermissionReasonShow(true)
                                                    setPermissionAlertShow(true)
                                                }
                                            }
                                        }}
                                        onCancel={() => {
                                            setsweetAlertShow(false)
                                        }}
                                    />
                                    <DPPrintOption
                                        confirm_both={printoptionShow}
                                        title={menuName}
                                        description={permissionAlertTitle}
                                        showReason={permissionReasonShow}
                                        nameDisable={permissionNameDisable}
                                        showCancel={true}
                                        cancelColor={"danger"}
                                        onConfirmpdf={() => {
                                            handlesave("", 1)
                                            setprintoptionShow(false)
                                        }}
                                        onConfirmxcel={() => {
                                            handlesave("", 2)
                                            setprintoptionShow(false)
                                        }}
                                        onCancel={() => {
                                            setprintoptionShow(false)
                                        }}
                                    />
                                    <DPPermission
                                        confirm_both={permissionAlertShow}
                                        title={menuName}
                                        description={permissionAlertTitle}
                                        showReason={permissionReasonShow}
                                        nameDisable={permissionNameDisable}
                                        showCancel={true}
                                        btnColor={"success"}
                                        cancelColor={"danger"}
                                        AlName={permissionName}
                                        AlNameOnchange={e => {
                                            let val2 = Text(e.target, 50, true, false, "any", true)
                                            setPermissionName(val2)
                                        }}
                                        AlPassward={permissionPassword}
                                        AlPasswardOnchange={e => {
                                            let val2 = Text(e.target, 50, true, true, "any", true)
                                            setPermissionPassword(val2)
                                        }}
                                        AlReason={Reason}
                                        AlReasonOnchange={e => {
                                            let val2 = Text(e.target, 50, true, false, "any", true)
                                            setReason(val2)
                                        }}
                                        onConfirm={() => {
                                            setPermissionAlertShow(false)
                                            if (AlertConfirmOption == 1) {
                                                permission("Save")
                                            } else if (AlertConfirmOption == 5) {
                                                permission("Delete")
                                            } else if (AlertConfirmOption == 6) {
                                                permission("Print")
                                            }
                                        }}
                                        onCancel={() => {
                                            setPermissionAlertShow(false)
                                            clearPermissionInputs()
                                        }}
                                    />
                                    <DPLoadingAlert
                                        confirm_both={loadingAlert}
                                        title={loadingAlertTitle}
                                    />
                                    <DPTopToolBar
                                        //Help Button
                                        helpEnable={helpUrl != "" ? true : false}
                                        helpClick={() => {
                                            window.open(helpUrl)
                                        }}
                                        //Favorite Button
                                        favoriteEnable={true}
                                        favoriteClick={handleFavourite}
                                        //New Button
                                        newEnable={true}
                                        newClick={() => {
                                            setAlertDescription("Do you wish to refresh the screen ?");
                                            setAlertConfirmOption(4)
                                            setsweetAlertShow(true)
                                        }}
                                        //Save Button
                                        saveEnable={saveEnable}
                                        saveClick={() => {
                                            setAlertDescription("Do you wish to save ?");
                                            setAlertConfirmOption(1)
                                            setsweetAlertShow(true)
                                        }}
                                        //ProcessButton
                                        processEnable={false}
                                        processClick={() => {
                                            alert("Process")
                                        }}
                                        //Edit Button
                                        editEnable={editEnable}
                                        editClick={() => {
                                            setAlertDescription("Do you wish to edit ?");
                                            setAlertConfirmOption(2)
                                            setsweetAlertShow(true)
                                        }}
                                        //Print Button
                                        printEnable={printEnable}
                                        printClick={() => {
                                            setReason("Printed")
                                            setAlertDescription("Do you wish to print ?");
                                            setAlertConfirmOption(6)
                                            setsweetAlertShow(true)
                                        }}
                                        //Delete Button
                                        deleteEnable={deleteEnable}
                                        deleteClick={() => {
                                            setReason("Deleted")
                                            setAlertDescription("Do you wish to delete ?");
                                            setAlertConfirmOption(5)
                                            setsweetAlertShow(true)
                                        }}
                                        //Exit Button
                                        exitEnable={true}
                                        exitClick={() => {
                                            setAlertDescription("Do you wish to exit ?");
                                            setAlertConfirmOption(3)
                                            setsweetAlertShow(true)
                                        }}
                                    />
                                    <DPNavBar buttons={newTabList} activeStatus={customActiveTab} />
                                    <TabContent activeTab={customActiveTab} className="p-3 text">
                                        {show ? (
                                            <Alert color={AlertColor} role="alert">
                                                {AlertMsg}
                                                <br />
                                                <small>{ErrorMsg}</small>
                                            </Alert>
                                        ) : null}

                                        <TabPane tabId="1">
                                            <ReportMasterContent
                                                reportUI={reportUI}
                                                menuCode={menuCode}
                                                toggleLocation1={toggleLocation1}
                                                isLocation_1_open={isLocation_1_open}
                                                toggleLocation2={toggleLocation2}
                                                isLocation_2_open={isLocation_2_open}

                                                setAllLocations_1={setAllLocations_1}
                                                allLocations_1={allLocations_1}
                                                setIsAllLocations_1={setIsAllLocations_1}
                                                isAllLocations_1={isAllLocations_1}
                                                allLocations_2={allLocations_2}
                                                setAllLocations_2={setAllLocations_2}
                                                isAllLocations_2={isAllLocations_2}
                                                setIsAllLocations_2={setIsAllLocations_2}

                                                isCustomerGroup_open={isCustomerGroup_open}
                                                toggleCustomerGroup={toggleCustomerGroup}
                                                allCustomerGroup={allCustomerGroups}
                                                setAllCustomerGroups={setAllCustomerGroups}
                                                isAllCustomerGroups={isAllCustomerGroups}
                                                setIsAllCustomerGroups={setIsAllCustomerGroups}

                                                isCustomer_open={isCustomer_open}
                                                toggleCustomer={toggleCustomer}
                                                allCustomers={allCustomers}
                                                setAllCustomers={setAllCustomers}
                                                isAllCustomers={isAllCustomers}
                                                setIsAllCustomers={setIsAllCustomers}

                                                isOffer_open={isOffer_open}
                                                toggleOffer={toggleOffer}
                                                allOffers={allOffers}
                                                setAllOffers={setAllOffers}
                                                isAllOffers={isAllOffers}
                                                setIsAllOffers={setIsAllOffers}


                                                isPayementMethod_open={isPayementMethod_open}
                                                togglePayementMethod={togglePayementMethod}
                                                allPayementMethods={allPayementMethods}
                                                setAllPayementMethods={setAllPayementMethods}
                                                isAllPayementMethods={isAllPayementMethods}
                                                setIsAllPayementMethods={setIsAllPayementMethods}

                                                isProduct_open={isProduct_open}
                                                toggleProduct={toggleProduct}
                                                allProducts={allProducts}
                                                setAllProducts={setAllProducts}
                                                isAllProducts={isAllProducts}
                                                setIsAllProducts={setIsAllProducts}

                                                isStaff_open={isStaff_open}
                                                toggleStaff={toggleStaff}
                                                allStaff={allStaff}
                                                setAllStaff={setAllStaff}
                                                isAllStaff={isAllStaff}
                                                setIsAllStaff={setIsAllStaff}

                                                isSupplier_open={isSupplier_open}
                                                toggleSupplier={toggleSupplier}
                                                allSuppliers={allSuppliers}
                                                setAllSuppliers={setAllSuppliers}
                                                isAllSuppliers={isAllSuppliers}
                                                setIsAllSuppliers={setIsAllSuppliers}

                                                isTxnType_open={isTxnType_open}
                                                toggleTxnType={toggleTxnType}
                                                allTxnTypes={allTxnTypes}
                                                setAllTxnTypes={setAllTxnTypes}
                                                isAllTxnTypes={isAllTxnTypes}
                                                setIsAllTxnTypes={setIsAllTxnTypes}
                                                setTxnDescription={setTxnDescription}
                                                txnDescription={txnDescription}

                                                isUser_open={isUser_open}
                                                toggleUser={toggleUser}
                                                allUsers={allUsers}
                                                setAllUsers={setAllUsers}
                                                isAllUsers={isAllUsers}
                                                setIsAllUsers={setIsAllUsers}

                                                setFromDate={setFromDate}
                                                setToDate={setToDate}
                                                fromDate={fromDate}
                                                toDate={toDate}
                                                isAllDates={isAllDates}
                                                setIsAllDates={setIsAllDates}


                                                groups={groups}
                                                setGroups={setGroups}
                                                isSubGroup={isSubGroup}
                                                setIsSubGroup={setIsSubGroup}
                                                setSubGroups={setSubGroups}
                                                subGroups={subGroups}
                                                currentGroup={currentGroup}
                                                setCurrentGroup={setCurrentGroup}
                                                GroupStatesArray={GroupStatesArray}
                                                setEndGroups={setEndGroups}
                                                endFroups={endFroups}
                                                handlesave={handlesave}
                                                displayDataset={displayDataset}
                                            />
                                        </TabPane>
                                        <TabPane tabId="2">
                                            <ReportMasterTable
                                                displayDataset={displayDataset}
                                            />
                                        </TabPane>
                                    </TabContent>
                                    {/* <Row>
                                        <Col sm={12} md={6} className="mb-4-sm">
                                            <Row>
                                                <Button
                                                    color="primary"
                                                    onClick={() => {
                                                        handlesave("save")
                                                    }}
                                                    disabled={displayDataset.length > 0 ? true : false}>
                                                    Get Data
                                                </Button>
                                            </Row>
                                        </Col>
                                    </Row> */}

                                    <Row>
                                        {crEnable ? (
                                            <DPInfoBox
                                                createdBy={crBy}
                                                createdOn={crDate != '1900-01-01T00:00:00' ? crDate : ''}
                                                modifiedBy={mdBy}
                                                modifiedOn={mdDate != '1900-01-01T00:00:00' ? mdDate : ''}
                                            />
                                        ) : null}
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>

        </React.Fragment>
    )

}

export default ReportMaster